<template>
  <div id="app" class="imgzo">
    <keep-alive >
      <router-view />
    </keep-alive>
<!--  带查询参数，下面的结果为 /register?plan=private -->
<!--  <router-link :to="{ path: 'register', query: { plan: 'private' }}">Register</router-link>  -->
<!--  有时候想要 <router-link> 渲染成某种标签，例如 <li>。 于是我们使用 tag prop 类指定何种标签，同样它还是会监听点击，触发导航。 -->
<!--  <router-link to="/foo" tag="li">foo</router-link> -->
<!--  渲染结果 -->
<!--  <li>foo</li>  ---->
  </div>
</template>

<script>
import "@/assets/css/zoStyle.css"

export default {
  name: "App",

  data() {
    return {
    };
  },
  
  // 医院机构二维码访问：https://e.imgzo.cn/query?Hid=1755002&aT=1
  // Hid--HospitalID:对应数据库中，医院在平台的ID号；
  // aT--accessType:访问类别，取值:1--query验证登录;2--专属扫码；3--分享扫码;4--历史记录内部跳转;
  // 患者专属二维码访问：https://e.imgzo.cn/df/index?Hid=1755001&cNo=158152&mT=DR&aT=2&token=abcd#1234X
  // cNo--checkNo:查检号对应各家医院的每份检查的唯一ID。（不同医院间可能相同）
  // mT--ModalityType:检查类型，取值：CT/DR/MR/MG/US/DSA等支持的类型。
  // 患者分享二维码访问：https://e.imgzo.cn/df/index?Hid=1755001&cNo=158152&mT=DR&aT=3&vP=1&iVh=false&iEa=0&token=abcd#1234X
  // vp--validPeriod:分享二维码有效期，取值单位30分钟。
  // iEa--isEncryptAccess:是否加密访问，取值0和1。
  // iVh--isAllowViewHistory:是否允许查看历史检查，取值true or false
  // 内部跳转访问：https://e.imgzo.cn/df/index?Hid=1755001&cNo=158152&mT=DR&aT=4&token=abcd#1234X
  // 内部跳转通过params带有数据，不需要查询数据库！
  methods: {

  }
};
</script>
